__turbopack_context__.v({
  "button": "Checkbox-module-sass-module__4jkiKG__button",
  "checkmark": "Checkbox-module-sass-module__4jkiKG__checkmark",
  "error": "Checkbox-module-sass-module__4jkiKG__error",
  "title": "Checkbox-module-sass-module__4jkiKG__title",
});
